import { ASYNC_SUFFIX_DELIMITER, ASYNC_SUFFIXES } from './constants';

export const createAsyncActionTypesFactory =
    (asyncSuffixes = ASYNC_SUFFIXES, asyncSuffixDelimiter = ASYNC_SUFFIX_DELIMITER) =>
    (type: string): [string, string, string] => {
        const createAsyncActionType = (asyncSuffix: string) => `${type}${asyncSuffixDelimiter}${asyncSuffix}`;
        return [
            createAsyncActionType(asyncSuffixes[0]),
            createAsyncActionType(asyncSuffixes[1]),
            createAsyncActionType(asyncSuffixes[2]),
        ];
    };

export default createAsyncActionTypesFactory();
